// import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

const PREFIX = '_section';

const classes = {
  content: `${PREFIX}-content`,
  icon: `${PREFIX}-icon`,
};

const MyDivider = styled(Divider)(({ theme }) => ({
  borderBottomColor: '#474747',
  borderBottomWidth: 7,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(4),
  width: '100%',
  [`& .${classes.icon} > img`]: {
    width: 70,
  },
  [`& .${classes.content}`]: {},
}));

interface IProps {
  id?: string;
  title?: string;
  icon?: JSX.Element;
  children: JSX.Element;
}

export default function Section(props: IProps): JSX.Element {
  const { id, title, children, icon } = props;
  return (
    <Root id={id}>
      {icon && false && <div className={classes.icon}>{icon}</div>}
      <MyDivider />
      {title && (
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
          {title}
        </Typography>
      )}
      <div className={classes.content}>{children}</div>
    </Root>
  );
}
